import type {
  CampaignStatus,
  CampaignType,
  Goal,
  Structure,
  Tag,
  Type,
  UserType,
} from './types'

// Single source of truth for the API-enum → display-label conversion. The
// GraphQL schema uses camelCase enum values (e.g. `caseStudy`); the UI was
// originally written against the display strings the Notion sync produced
// (e.g. `Case Study`), so we still convert at the read edge.

export const TYPE_LABELS: Record<string, Type> = {
  tip: 'Tip',
  caseStudy: 'Case Study',
  story: 'Story',
  howTo: 'How-to',
  question: 'Question',
  behindTheScenes: 'Behind the Scenes',
  opinion: 'Opinion',
  list: 'List',
}

export const GOAL_LABELS: Record<string, Goal> = {
  engagement: 'Engagement',
  connection: 'Connection',
  reflection: 'Reflection',
  expertise: 'Expertise',
  promotion: 'Promotion',
  education: 'Education',
  celebration: 'Celebration',
}

export const STRUCTURE_LABELS: Record<string, Structure> = {
  singleText: 'Single Text',
  threaded: 'Threaded',
}

export const USER_TYPE_LABELS: Record<string, UserType> = {
  business: 'Business',
  individual: 'Individual',
}

export const TAG_LABELS: Record<string, Tag> = {
  new: 'New',
  featured: 'Featured',
}

export const CAMPAIGN_STATUS_LABELS: Record<string, CampaignStatus> = {
  draft: 'Draft',
  active: 'Active',
  ended: 'Archived',
}

export const CAMPAIGN_TYPE_LABELS: Record<string, CampaignType> = {
  collection: 'Collection',
  dripCampaign: 'Drip Campaign',
  creatorCamp: 'Creator Camp',
}

/** Maps an API value to a display label, dropping unknown values. */
function narrow<T extends string>(
  values: readonly string[] | null | undefined,
  labels: Record<string, T>,
): T[] {
  const out: T[] = []
  for (const v of values ?? []) {
    const label = labels[v]
    if (label) out.push(label)
  }
  return out
}

export const narrowUserTypes = (
  values: readonly string[] | null | undefined,
): UserType[] => narrow(values, USER_TYPE_LABELS)

export const narrowTags = (
  values: readonly string[] | null | undefined,
): Tag[] => narrow(values, TAG_LABELS)
